import { useController, useFormContext } from 'react-hook-form';

import { Checkbox, type CheckboxProps } from '../../components/Checkbox';
import { FieldError } from '../../components/FieldError';

export interface RHFCheckboxProps extends CheckboxProps {
    name: string;
    required?: boolean;
    onAfterChange?: (value: boolean) => void;
}

export const RHFCheckbox = ({
    defaultChecked = false,
    disabled = false,
    label,
    dataTestid,
    name,
    description,
    htmlAttributes,
    onAfterChange,
}: RHFCheckboxProps) => {
    const { control } = useFormContext();
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: defaultChecked,
    });

    return (
        <div>
            <Checkbox
                name={field.name}
                label={label}
                checked={typeof field.value === 'boolean' ? field.value : false}
                defaultChecked={defaultChecked}
                dataTestid={dataTestid}
                htmlAttributes={htmlAttributes}
                description={description}
                disabled={disabled}
                onChange={(value) => {
                    field.onChange(value);
                    return onAfterChange?.(value);
                }}
            />
            {fieldState.error?.message && <FieldError>{fieldState.error?.message}</FieldError>}
        </div>
    );
};
